import React, { useContext } from 'react';
import { Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Logo } from './design';
import { AuthContext } from '../contexts/AuthContext';

const MONO = "'IBM Plex Mono', monospace";

const FLink = ({ to, children }) => (
  <Box
    component={RouterLink}
    to={to}
    sx={{
      textDecoration: 'none',
      color: '#8298bd',
      fontSize: '13.5px',
      transition: 'color .15s',
      '&:hover': { color: '#f4f8ff' },
    }}
  >
    {children}
  </Box>
);

const Footer = () => {
  const { isAuthenticated } = useContext(AuthContext);
  return (
  <Box
    component="footer"
    sx={{
      background: '#070e1c',
      borderTop: '1px solid rgba(120,150,200,.16)',
      py: '40px',
      px: '28px',
    }}
  >
    <Box
      sx={{
        maxWidth: '1200px',
        mx: 'auto',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '18px',
      }}
    >
      <Logo size={28} to={isAuthenticated ? '/dashboard' : '/'} />
      <Box sx={{ fontFamily: MONO, fontSize: '12px', color: '#5f7398' }}>
        © {new Date().getFullYear()} PANDID — P&ID Information Extraction
      </Box>
      <Box sx={{ display: 'flex', gap: '22px' }}>
        <FLink to="/learn-more">How it works</FLink>
        <FLink to="/pricing">Pricing</FLink>
        <FLink to="/login">Log in</FLink>
      </Box>
    </Box>
  </Box>
  );
};

export default Footer;
